export const DATE_FORMAT = "dd/MM/yyyy";
export const DATE_PICKER_PLACEMENT = "bottom-start";
export const DATE_PICKER_OFFSET = 4;
